package tools

import kotlinx.browser.localStorage
import net.sergeych.boss_serialization_mp.BrowserBinaryStorage
import net.sergeych.boss_serialization_mp.KVStorage
import net.sergeych.boss_serialization_mp.optStored

val browserStorage = KVStorage(BrowserBinaryStorage(localStorage, "params"))

inline fun <reified T>storedParam() = optStored<T>(browserStorage)